/**
 * Shared constants for the yards / location-scheme feature.
 */

/**
 * Maximum number of locations a single storage area may generate. Enforced when
 * a scheme is applied with concrete per-area ranges (mirrors the backend
 * `MAX_LOCATIONS`). Schemes themselves are structure-only and have no count.
 */
export const MAX_AREA_LOCATIONS = 100_000;
